module.exports = __webpack_public_path__ + "static/media/navidad9.7da860ac.jpg";